module.exports = __webpack_public_path__ + "static/index/img/baikal-505.71f594d3.jpg";